import { get } from './index';

export const getDistributedItemsProducts = async (organizationId) => {
  const resp = await get(`/api/v1/products?organization_id=${organizationId}`);
  return resp.json();
};
